export default __webpack_public_path__ + "static/media/306.4d81d407.png";